var cymasmooth = require('cymasmooth');

var onShow = function(el, callback){
	setTimeout(function() {
		callback();
	}, 50);
};

cymasmooth.registerFunc('onShow', onShow);